<ng-template #image>
  <img
    loading="lazy"
    [alt]="component()?.description"
    [src]="
      component()?.image
        | imageVariant: {width: 1920, height: 1080, format: '.webp', quality: 90}
    "
  />
</ng-template>
@if (component()?.external_url) {
<a target="_blank" [href]="component()?.external_url">
  <ng-container *ngTemplateOutlet="image"></ng-container>
</a>
} @else {
<ng-container *ngTemplateOutlet="image"></ng-container>
}
